import React from 'react';
import { useReveal } from '../lib/useReveal';
import { CheckIcon } from '../lib/icons';
const OUTCOMES = ['Comprender los principios del Reiki.', 'Realizar sesiones completas.', 'Trabajar con Chakras.', 'Aplicar Reiki a distancia.', 'Desarrollar una práctica profesional.', 'Continuar creciendo espiritualmente.'];
export function OutcomesSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#F4F2EE] py-20 md:py-32 px-5 sm:px-6 border-t border-[#EAE6E1]" data-id="element-276">
      <div className="container mx-auto max-w-5xl" data-id="element-277">
        <div ref={ref1} className={`reveal text-center mb-16 md:mb-20 ${vis1 ? 'is-visible' : ''}`} data-id="element-278">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E2330] leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-279">
            Al finalizar esta formación vas a poder...
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-280">
          {OUTCOMES.map((outcome, idx) => <div key={idx} className="bg-white rounded-3xl p-8 shadow-[0_10px_30px_rgba(0,0,0,0.03)] border border-[#EAE6E1] flex items-start gap-5 transition-all duration-300 hover:shadow-[0_15px_40px_rgba(0,0,0,0.06)] hover:-translate-y-1" data-id="element-281">
              <span className="flex-shrink-0 w-10 h-10 rounded-full bg-[#FAFAF8] flex items-center justify-center border border-[#EAE6E1]" data-id="element-282">
                <CheckIcon className="w-5 h-5 text-[#D4AF37]" strokeWidth={2.5} data-id="element-283" />
              </span>
              <p className="text-[#1E2330] text-lg font-semibold leading-snug pt-1.5" data-id="element-284">
                {outcome}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}